import { legacyPlugins } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/node_modules/.pnpm/@unhead+vue@3.4.1_@oxc-project+types@0.151.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_994ddca797a1dd770b78d9b6de16cc08/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}